import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["href"]

import { Attachment } from '../../store/useMessages'
import { Capacitor } from '@capacitor/core'
import { MessagesModel } from '../../models/MessagesModel'
import { onBeforeMount, ref } from 'vue'
import { useNetwork } from '../../composables/useNetwork'
/**
 * This component renders attachment link. In browser it is simply a link to the
 * resource. In native mode, it checks for the attachment in the system. If not there,
 * it will download it.
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'AttachmentLink',
  props: {
    attachment: {}
  },
  setup(__props: any) {

const props = __props
const isNative = Capacitor.isNativePlatform()
const onDevice = ref(false)
//wrapper
const checkOnDevice = async () => {
  return await MessagesModel().attachmentOnDevice(props.attachment)
}
const openNative = async () => {
  if (!getStatus.value) {
    return
  }
  console.log('open native')
  //download and open
  if (!onDevice.value) {
    await download()
  }
  //check one more time, value may have changed after download
  if (onDevice.value) {
    console.log('open attachment')
    await MessagesModel().openAttachment(props.attachment)
  }
}
const { getStatus } = useNetwork()
const isDownloading = ref(false)
const download = async () => {
  isDownloading.value = true
  await MessagesModel().downloadAttachment({
    id: props.attachment.id,
    name: props.attachment.name,
    url: props.attachment.link,
  })
  isDownloading.value = false
  onDevice.value = await checkOnDevice()
}

onBeforeMount(async () => {
  onDevice.value = await checkOnDevice()
})

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_spinner = _resolveComponent("q-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isNative) && _unref(getStatus))
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "text-primary underline row",
          onClick: openNative
        }, [
          _createVNode(_component_q_icon, {
            name: "attachment",
            size: "sm",
            color: "grey-7",
            class: "q-mr-xs"
          }),
          (!onDevice.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Download")
              ], 64))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.attachment.name), 1)
        ]))
      : (_unref(isNative) && !_unref(getStatus))
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(onDevice.value ? 'text-primary underline row' : 'text-black row'),
            onClick: openNative
          }, [
            _createVNode(_component_q_icon, {
              name: "attachment",
              size: "sm",
              color: "grey-7",
              class: "q-mr-xs"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.attachment.name), 1)
          ], 2))
        : (_openBlock(), _createElementBlock("a", {
            key: 2,
            class: "text-primary underline",
            href: _ctx.attachment.link,
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            _createVNode(_component_q_icon, {
              name: "attachment",
              size: "sm",
              color: "grey-7",
              class: "q-mr-xs"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.attachment.name), 1)
          ], 8, _hoisted_2)),
    (isDownloading.value)
      ? (_openBlock(), _createBlock(_component_q_spinner, {
          key: 3,
          color: "primary",
          size: "sm"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})